'use client';

import { SEARCH_TARGET_VALUES } from '@/types/types';
import { useLogic } from './logic';
import { SelectPortalOfficeTypeButton } from '@/features/station/SelectPortalOfficeTypeButton';
import { Loading } from '@/components/loader/Loading';

type Props = {
  type: SEARCH_TARGET_VALUES;
  isPublicSearch?: boolean;
};

export function SearchTargetSwitch({ type, isPublicSearch = false }: Props) {
  const { activeValue, handleToggle, isPending } = useLogic({
    type,
    isPublicSearch,
  });
  return (
    <>
      <SelectPortalOfficeTypeButton
        activeValue={activeValue}
        onChange={handleToggle}
      />
      <Loading isLoading={isPending} />
    </>
  );
}
